import React, {useState} from "react";
//import logo from "../../assets/img/Logo_Izzi.svg";
import {API_BASE} from "../../services/apirest";
import axios from "axios";
import {useNavigate} from "react-router-dom";

export const Login = () => {
    const [form, setForm] = useState({
        usuario: "", password: "",
    });
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const navigate = useNavigate();
const manejadorSubmit = async (e) => {
  e.preventDefault();
  setError(false); setErrorMsg("");

  try {
    const url = `${API_BASE}/auth.php`; // ⚠️ si usabas /auth, prueba con auth.php
    console.log("API_BASE=", API_BASE, "URL=", url);

    const resp = await axios.post(url, form, {
      headers: { "Content-Type": "application/json" },
      // NO lances por 4xx/5xx, así vemos el body/headers
      validateStatus: () => true,
      // Si PHP imprime warnings y rompe el JSON, nos llega string
      transformResponse: [(d) => d],
    });

    console.log("status:", resp.status, "ct:", resp.headers?.["content-type"]);
    console.log("raw body:", resp.data);

    // Si está caído o 404, muestra mensaje claro
    if (resp.status === 0 || resp.status === 404) {
      throw new Error(`Endpoint no accesible (${resp.status}). Revisa la URL/ruta.`);
    }
    if (resp.status >= 500) {
      throw new Error(`Servidor respondió ${resp.status}. Revisa logs PHP/Apache.`);
    }

    // Normaliza JSON
    let data = resp.data;
    if (typeof data === "string") {
      try { data = JSON.parse(data); }
      catch { throw new Error("La respuesta no es JSON válido (¿warnings de PHP/CORS?)."); }
    }

    const result = data?.result ?? data ?? {};
    const token  = result?.token;
    if (!token) {
      const msg = result?.error_msg || data?.message || `Login rechazado (${resp.status}).`;
      setError(true); setErrorMsg(msg);
      return;
    }

    localStorage.setItem("token", token);
    if (result?.rol_id != null) localStorage.setItem("rol_id", String(result.rol_id));
    if (result?.numero_vendedor != null) localStorage.setItem("numero_vendedor", String(result.numero_vendedor));
    navigate("/");
  } catch (err) {
    console.error("Axios/submit error:", err);
    setError(true);
    setErrorMsg(err?.message || "Error al conectar al API");
  }
};


    const manejadorChange = (e) => {
        setForm({
            ...form, [e.target.name]: e.target.value,
        });
    };



    return (
        <section className="login-section">
            <div className="login-container">
                <div className="login-box">
                    <h1 className="login-title">ADMINISTRADOR COMERCIAL</h1>
                    <form onSubmit={manejadorSubmit} className="login-form">
                        <div className="input-group">
                            <i className="bi bi-person-fill input-icon"></i>
                            <input
                                type="text"
                                name="usuario"
                                placeholder="Usuario"
                                onChange={manejadorChange}
                                className="login-input"
                            />
                        </div>
                        <div className="input-group">
                            <i className="bi bi-lock-fill input-icon"></i>
                            <input
                                type="password"
                                name="password"
                                placeholder="Contraseña"
                                onChange={manejadorChange}
                                className="login-input"
                            />
                        </div>
                        <button
                            type="submit"
                            className="login-button"
                        >
                            Iniciar sesión
                        </button>
                    </form>
                    {error && (<div className="alert alert-danger mt-3" role="alert">
                        {errorMsg}
                    </div>)}
                </div>
            </div>
        </section>);
};